// extracted by mini-css-extract-plugin
export default {"cls1":"InviteRegisterTOTP-Container_cls1__11ctE","cls2":"InviteRegisterTOTP-Container_cls2__C5MGc InviteRegisterTOTP-Container_cls1__11ctE"};